'use client';
import Auth from '@/components/app/auth/components';

import useCommonModalStore from '@/store/common-modal-store';

const UseUserAuth = () => {
  const { setShow } = useCommonModalStore();

  const openModal = () => {
    setShow(true, {
      DialogPanelProps: { className: 'rounded-xl overflow-hidden shadow-none!  p-0! bg-transparent!' },
      Body() {
        return <Auth />;
      },
    });
  };

  return openModal;
};
export default UseUserAuth;
